import { reactive, computed } from 'vue';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export const useTopicsForm = () => {
    const state = reactive({
        id: '',
        title: '',
        codigo: '',
        body: '',
        target: null,
        status: 1,
    });

    const setState = (c) => {
        state.id = c.id;
        state.title = c.title;
        state.codigo = c.codigo;
        state.body = c.body;
        state.target = c.target;
        state.status = c.status;
    };

    const rules = computed(() => ({
        title: { required },
        codigo: { required },
        body: { required },
    }));

    const $v = useVuelidate(rules, state);

    return {
        state,
        setState,
        $v,
        rules,
    };
};

export default {};
